import PrimaryMenu from "./Pages/PrimaryMenu/PrimaryMenu";
import WhatWeDo from "./Pages/WhatWeDo/index";

const menu = new PrimaryMenu();
menu.pages();

new WhatWeDo();
